import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from '../home';
import Download from '../download';
import QcodeDownload from '../qcode-download';
import AuthBind from '../../components/auth-bind';
import { init } from './init';

const App = () => {
  const [tokenObj, setTokenObj] = useState();
  const getTokenObj = async () => {
    const result = await init();
    if (result) {
      setTokenObj(result);
    }
  };
  useEffect(() => {
    getTokenObj();
  }, []);

  return (
    <>
      <Router>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/official/download" element={<Download />} />
          {process.env.REACT_APP_MODE === 'dev' && (<Route exact path="/official/qcode-download" element={<QcodeDownload />} />)}
        </Routes>
      </Router>
      <AuthBind tokenObj={tokenObj} />
    </>
  );
}

export default App;
